import { HEX_COLOR } from '@shared/color';
import { primaryCss } from './prefs';
import type { Branding } from './types/api';

export const DEFAULT_PRODUCT = 'ResolveOne';
const STYLE_ID = 'tenant-branding';

/**
 * Applies tenant branding as CSS custom properties (see primaryCss for the dark-mode readability rule).
 * A personal accent chosen in Settings is kept after this element so it takes precedence.
 */
export function applyBranding(b: Pick<Branding, 'primaryColor' | 'productName'> | null): void {
  if (typeof document === 'undefined') return;
  let el = document.getElementById(STYLE_ID);
  if (!el) {
    el = document.createElement('style');
    el.id = STYLE_ID;
    document.head.appendChild(el);
  }
  const color = b && HEX_COLOR.test(b.primaryColor) ? b.primaryColor.toLowerCase() : null;
  el.textContent = color ? primaryCss(color) : '';
  const accent = document.getElementById('user-accent');
  if (accent) document.head.appendChild(accent); // keep the personal accent last so it wins
  document.title = b?.productName ?? DEFAULT_PRODUCT;
}
